import React from "react";
import { PeriodDateJson } from "../../../../models/dtos/chart/PeriodDateJson";
import { PeriodDate, PeriodDateTypeString } from "../../../../models/interfaces/chart/PeriodDate";
import GlobalSerivce from "../../../../services/base/GlobalSerivce";
import './DatePickerPeriod.scss';
import DatePickerPeriodState, { DatePickerPeriodProps } from "./DatePickerPeriod.models";

export default class DatePickerPeriod extends React.PureComponent<DatePickerPeriodProps, DatePickerPeriodState> {

    globalSerivce: GlobalSerivce;
    constructor(props: any) {
        super(props);

        this.globalSerivce = new GlobalSerivce();
        this.state = { staticDate: [], isActiveDatePicker: false };
    }

    componentDidMount() {
        let self = this;

        self.globalSerivce.getPeriodDate().then(function (response) {
            self.setState({ staticDate: response });
            self.receiveData(response.filter(date => date.periodDate === PeriodDate.CurrentMonth)[0]);
        });
    }

    receiveData(periodDate: PeriodDateJson) {
        let self = this;

        self.setState({ isActiveDatePicker: false });
        self.props.afterSelect(periodDate);
    }

    changeActiveDatePicker = (value: boolean) => {
        let self = this;

        self.setState({ isActiveDatePicker: value });
    }

    render(): React.ReactNode {
        let headerContent;
        let content;
        if (this.state.isActiveDatePicker) {
            headerContent = (<span className="mdi mdi-close" onClick={() => this.changeActiveDatePicker(false)}></span>);
            content = (<div className="period-date-picker-area" style={{ textAlign: "right" }}>
                <div className="title">
                    <label>بازه زمانی</label>
                </div>
                <div className="btn-date">
                    {this.state.staticDate.map((date, key) => {
                        return <button key={key} className="date-picker-bottom" style={{ color: this.props.color, border: "solid 1px " + this.props.color }} onClick={() => this.receiveData(date)}>
                            {PeriodDateTypeString(date.periodDate)}
                        </button>
                    })}
                </div>
            </div>);
        }
        else
            headerContent = (<span className="mdi mdi-calendar" onClick={() => this.changeActiveDatePicker(true)}></span>);

        return (<>
            <div className="header period-date-picker-area">
                <div className="px-12">
                    {headerContent}
                </div>
            </div>

            {content}
        </>)
    }
}